export const PATH_TO_SESSIONS_STATE = "sessions";
export const PATH_TO_SESSION_MODULES_STATE = "sessionModules";
